// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__n_Pkg","dragIcon":"Choice_dragIcon__1riYD","left":"Choice_left__1Ugqk","input":"Choice_input__1uuDE"};